import TechStack from "../components/TechStack"

const References = () => {
    return (
        <div className="flex justify-center items-center m-auto lg:max-w-[100%] bg-transparent my-5 gap-3">
            <div className="w-full">
                <TechStack />
            </div>
        </div>
    )
}
export default References